import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonProps } from "@material-ui/core";
import { AccountToEdit } from "./types";
import FormDialog from "./FormDialog";

type Params = {
  accountToEdit?: AccountToEdit;
} & ButtonProps;

export default function AddOrEditAccount({ accountToEdit, ...rest }: Params) {
  const { t } = useTranslation("accounts");
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <div>
      <Button
        color={accountToEdit ? "default" : "primary"}
        data-testid={
          accountToEdit
            ? "accounts__edit-account-btn"
            : "accounts__add-account-btn"
        }
        disableElevation
        onClick={event => {
          event.stopPropagation();
          setOpenDialog(true);
        }}
        variant="contained"
        {...rest}
      >
        {accountToEdit ? t("common:edit") : t("buttons.addAccount")}
      </Button>
      {openDialog && (
        <FormDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          account={accountToEdit}
        />
      )}
    </div>
  );
}
